import React, { useState } from "react";
import CommonLayout from "../../layout/CommonLayout";
import CommonMenu from "../../layout/CommonMenu";
import CommonFooter from "../../layout/CommonFooter";
import { Link } from "react-router-dom";


const GNBPURE01001S = () => {

    const [isOpen, setIsOpen] = useState(false); // 드롭다운 메뉴 열림 상태
    const toggleDropdown = (e) => {
        e.preventDefault(); // 기본 동작 방지 (URL 변경 X)
        setIsOpen(!isOpen); // 상태 토글
    };

  return (
	<CommonLayout>
      <CommonMenu />
		<>
		  <div id="contents" className="container">
			<div className="sub-title bg-type02">
			  <h2>사업분야</h2>
			</div>

			<div className="location_wrap">
			  <ul className="depth1">
				<li>
				  <Link to="/">home</Link>
				</li>
				<li>
                    <a href="#none" onClick={toggleDropdown}>
                        SI<span></span>
                    </a>
				    <ul className="depth2" style={{ display: isOpen ? "block" : "none" }}>
                        <li>
                            <Link to="/GNBPURE01001S">시스템통합(SI)</Link>
                        </li>
                        <li>
                            <Link to="/GNBPURE01002S">시스템유지보수(SM)</Link>
                        </li>
                        <li>
                            <Link to="/GNBPURE01003S">솔루션 제공</Link>
                        </li>
                        <li>
                            <Link to="/GNBPURE01004S">
                                애플리케이션서비스 제공 (ASP)
                            </Link>
                        </li>
                        <li>
                            <Link to="/GNBPURE01005S">IT컨설팅 서비스</Link>
                        </li>
				    </ul>
				</li>
			  </ul>
			</div>

			<div id="cont" className="cont">
			  <div className="inner">
				<h3>
				  시스템 통합
				  <br />
				  (System Integration, SI)
				</h3>

				<article>
				  <p className="subtitle">GNB & Pure SI</p>
				  <p>
					자사가 제공하는 SI 서비스는 금융서비스 및 국가 정보화, 기업
					정보화 등 다양한 분야에 이르기까지{" "}
					<strong style={{ color: "red", fontWeight: "bold" }}>
					  자사의 각 분야별 전문가
					</strong>
					<strong>
					  (업종 전문가, 요소별 시스템구축 전문가, 요소별 기술 전문가,
					  사업관리 전문가)
					</strong>
					와{" "}
					<strong style={{ color: "red", fontWeight: "bold" }}>
					  보유하고 있는 솔루션
					</strong>
					의 유기적 결합을 통해 고객의 비즈니스 환경과 요구에 가장 적합한
					시스템을 구축함으로써 고객사의 경쟁력을 최상으로 이끌어내도록
					도와드리는 서비스입니다.
				  </p>
				</article>

				<article>
				  <p className="subtitle">고객의 전략적 목표달성</p>
				  <img src="/asset/img/subB/img_si1.png" alt="고객 비즈니스 환경에 적합한 최적의 시스템 구축" className="vis_img pc" />
				  <img src="/asset/img/subB/img_si1_mo.png" alt="고객 비즈니스 환경에 적합한 최적의 시스템 구축" className="mo" />
				</article>

				<article>
				  <p className="subtitle">SI 서비스 분야</p>
				  <img src="/asset/img/subB/img_si2.png" alt="고객 비즈니스 환경에 적합한 최적의 시스템 구축" className="vis_img pc" />
				  <img src="/asset/img/subB/img_si2_mo.png" alt="고객 비즈니스 환경에 적합한 최적의 시스템 구축" className="mo" />
				</article>
			  </div>
			</div>
		  </div>
		  <CommonFooter />
		</>
	</CommonLayout>
  );
};

export default GNBPURE01001S;
